/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISurveyQuestion } from 'app/shared/model/survey-question.model';
import { ISurveyOptionChoice } from 'app/shared/model/survey-option-choice.model';

export interface ISurveyQuestionOption {
  id?: string;
  weightage?: number | null;
  active?: boolean | null;
  cursor?: number;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  question?: ISurveyQuestion;
  optionChoice?: ISurveyOptionChoice;
}

export const defaultValue: Readonly<ISurveyQuestionOption> = {
  active: false,
};
